<template>
  <div class="cmp-elastic-product-details utlz-reset utlz-row">

    <!-- BESPOKE TRIS: Extra row for product title -->
    <div class="utlz-col-12 title-row">
      <h1>{{productDetails.shortDescription}}</h1>
    </div>
    <!-- END BESPOKE TRIS -->

    <!-- BESPOKE TRIS: Changed column to col-md-5 -->
      <div class="utlz-col-md-5 column-left">
        <!-- END BESPOKE TRIS -->
        <utlz-gallery :product="productDetails"></utlz-gallery>
        <!-- BESPOKE -->
        <div class="new-product-label" v-if="productDetails.customBooleans.PROD_NEW">
          <span v-translation="{ type: 'label', code: 'label_new' }"></span>
        </div>
        <!-- END BESPOKE -->
      </div>

      <!-- BESPOKE TRIS: Changed column to col-md-7 -->
      <div class="utlz-col-md-7 column-right product-details-column">
      <!-- END BESPOKE TRIS -->
          <div class="product-information">  
            <div class="ph-product-price" v-if="productDetails.prices.length">
                <utlz-product-price
                    :prices="productDetails.prices[0]"
                ></utlz-product-price>
            </div>

            <!-- BESPOKE TRIS: Restructures prod code, saleunit and stock -->
            <div class="top-specs">
              <div class="product-code">
                  <span v-translation="{ code: 'label_product_code', type: 'label' }"></span>
                  <span>{{productDetails.id}}</span>
              </div>
              <!-- BESPOKE TRIS -->
              <div class="saleunit" v-for="(prop, index) in Object.keys(productDetails.properties)" :key="index">          
                <span v-translation="{ code: 'label_free_text2', type: 'label' }"></span>
                <span>{{ productDetails.properties[prop] }}</span>          
              </div>
              <!-- END BESPOKE TRIS -->
              <utlz-product-stock
                :product="productDetails"
                :stock="productDetails.stock"
                :stockTotal="productDetails.stock"
              ></utlz-product-stock>
            </div>
            <!-- END BESPOKE TRIS -->

            <!-- <div class="product-specifications" v-if="productProperties.length > 0">
              <h2 v-translation="{ type: 'title', code: 'title_specifications' }"></h2>
              <div class="spec-list">
                <div class="spec-item" v-for="prop in productProperties" :key="prop.key">
                  <div class="spec-desc">
                    {{prop.key}}
                  </div>
                  <div class="spec-value">
                    {{prop.value}}
                  </div>
                </div>
              </div>
            </div> -->

            <!-- BESPOKE -->
            <div class="volume-discounts" v-if="productDetails.prices.length > 1">
              <div class="discount labels">
                <span class="quantity" v-translation="{ type: 'label', code: 'label_vd_quantity' }"></span>
                <span class="prijs" v-translation="{ type: 'label', code: 'label_vd_price' }"></span>
              </div>
              <div class="discount" v-for="price in productDetails.prices" :key="price.quantity">
                <div class="quantity">{{price.quantity}}</div>
                <div class="price">{{price.price}}</div>
              </div>
            </div>
            <!-- END BESPOKE -->

            <utlz-group-dropdown :variants="productVariants" />           
            

            <div class="order-product">
              <utlz-order-product
                v-if="showOrderProductControl && productDetails.prices.length"
                :product="productDetails"
                :useOrderComment="useOrderLineComments"
                >
                </utlz-order-product>

                <transition name="fade">
                  <p v-if="!showOrderProductControl && showStock" class="out-of-stock-msg">
                    <i class="fa fa-warning"></i>
                    <span v-translation="{ type: 'label', code: 'label_out_of_stock' }"></span>
                  </p>
                </transition>
            </div>

            <div class="favorite">
              <utlz-favorites-control v-if="showFavorites" :product="productDetails" :useDescription="true"></utlz-favorites-control>
            </div>
          </div>
      </div>

      <div class="utlz-col-12 margin-bottom-30"></div>

      <!-- BESPOKE TRIS: CHanged html structure -->
      <div class="utlz-col-12 prod-video" v-if="tabs[2].visible">
        <h3>{{tabs[2].description}}</h3>
        <div class="product-videos" v-if="videos.length">
          <utlz-product-videos :videos="videos"></utlz-product-videos>
        </div>
      </div>

      <div class="utlz-col-12 prod-desc" v-if="tabs[0].visible">
        <h3>{{tabs[0].description}}</h3>
        <div class="prod-desc-container">
          <div ref="productDescription" class="prod-desc-wrapper">
            <div class="product-long-description" v-html="productDetails.longDescription">
            </div>
          </div>
        </div>
        <!-- <a v-if="useCollapse" @click="expanded = !expanded" class="collapse-button theme-primary">
          <div v-if="!expanded" class="read-more">
            <span v-translation="{ type: 'button', code: 'link_description_read_more' }"></span>
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </div>
          <div v-if="expanded" class="read-less">
            <span v-translation="{ type: 'button', code: 'link_description_read_less' }"></span>
            <i class="fa fa-angle-up" aria-hidden="true"></i>
          </div>
        </a> -->
      </div>              

      <div class="utlz-col-12 prod-docs" v-if="tabs[1].visible">
        <h3>{{tabs[1].description}}</h3>
        <div class="product-documents">
          <utlz-product-documents :documents="documents"></utlz-product-documents>
        </div>
      </div>
        <!-- END BESPOKE TRIS-->

      <!-- BESPOKE TRIS: Disable matrix -->
      <!-- <div v-if="showOrderProductControl && productDetails.prices.length && productVariants.length" class="utlz-col-md-12">
        <utlz-group-matrix :variants="productVariants" />
      </div> -->
      <!-- END BESPOKE TRIS -->

      <div v-if="relatedProducts.upSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.upSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleUpSelling"
        ></utlz-product-carousel>
      </div>

      <div v-if="relatedProducts.crossSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.crossSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleCrossSelling"
        ></utlz-product-carousel>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductGroupMatrix from 'src/components/webshop/products/product-group/ProductGroupMatrix.vue';
import ProductGroupDropdown from 'src/components/webshop/products/product-group/ProductGroupDropdowns.vue';
import FavoritesControl from 'src/components/webshop/favorites/FavoritesControl.vue';
import Gallery from 'src/components/ui/gallery/Gallery.vue';
import ProductVideos from 'src/components/webshop/products/product-videos/ProductVideos.vue';
import ProductDocuments from 'src/components/webshop/products/product-documents/ProductDocuments.vue';
import ProductCarousel from 'src/components/webshop/products/product-carousel/ProductCarousel.vue';
export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-order-product': OrderProduct,
    'utlz-product-stock': ProductStock,
    'utlz-group-matrix': ProductGroupMatrix,
    'utlz-group-dropdown': ProductGroupDropdown,
    'utlz-favorites-control': FavoritesControl,
    'utlz-gallery': Gallery,
    'utlz-product-carousel': ProductCarousel,
    'utlz-product-videos': ProductVideos,
    'utlz-product-documents': ProductDocuments
  },
  data () {
    return {
      expanded: false,
      productDescriptionHeight: 0,
      titleUpSelling: window.vue.translations.title.title_product_relations,
      titleCrossSelling: window.vue.translations.title.title_product_relations_cross,
      tabs: [
        { id: 'description', description: window.vue.translations.label.label_tab_product_desc, active: true, visible: true },
        { id: 'documents', description: window.vue.translations.label.label_tab_product_documents, active: false, visible: false },
        { id: 'videos', description: window.vue.translations.label.label_tab_product_videos, active: false, visible: false }
      ]
    }
  },
  watch: {
    documents (val) { this.tabs[1].visible = val.length > 0; },
    videos (val) { this.tabs[2].visible = val.length > 0; }
  },
  computed: {
    ...mapState('productDetails', ['productDetails', 'productVariants', 'relatedProducts', 'videos']),
    ...mapGetters(['showStock', 'showPrices', 'showFavorites', 'showOrderProduct', 'stockLimit', 'useOrderLineComments', 'relatedProductBlockSize']),
    ...mapGetters('productDetails', ['documents']),
    useCollapse () {
      return this.productDescriptionHeight > 150;
    },
    showOrderProductControl () {
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.productDetails.stock !== null) {
          return this.stockLimit && this.productDetails.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    productProperties () {
      return Object.keys(this.productDetails.properties).map(x => {
        return { key: x, value: this.productDetails.properties[x] }
      });
    },
    images () {
      let images = [];

      images.push(this.productDetails.imageUrl)

      this.productDetails.images.forEach(element => {
        images.push(element);
      });

      return images
    }
  },
  updated () {
    if (this.$refs.productDescription !== undefined) {
      this.productDescriptionHeight = this.$refs.productDescription.clientHeight;
    }
  },
  created () {
    this.initDetails();
  },
  methods: {
    ...mapActions('productDetails', ['initDetails'])
  }
}
</script>

<style>

</style>
